import { Stack } from "@mui/material";
import { omit } from "lodash-es";
import type { FC } from "react";
import { prettyChannelName } from "../../../../channels/utils";
import { AdditionalRecipientsDatagrid } from "./components/additional-recipients-datagrid";
import { PreviewPersonsButton } from "./components/preview-persons-button";
import { PreviewTooltip } from "./components/preview-tooltip";
import type { PreviewProps } from "./types";
import { subjectToChange } from "./utils";

export const AdditionalRecipientsPreview: FC<PreviewProps<"only_additional_recipients">> = ({
  preview_config,
  channel,
  ...rest
}) => {
  const additionalRecipients = preview_config.data.additional_recipients;
  const recipientIds = preview_config.data.additional_recipient_ids;
  const channelName = prettyChannelName(channel);
  const recipientLabel = additionalRecipients === 1 ? "recipient" : "recipients";
  const peopleLabel = additionalRecipients === 1 ? "person" : "people";
  const tooltipTitle =
    `${additionalRecipients} named ${channelName} ${recipientLabel} for ` +
    `${additionalRecipients} ${peopleLabel} in the segment. ` +
    subjectToChange;

  return (
    <>
      <Stack direction="column" alignItems="flex-end" {...omit(rest, "data")}>
        <Stack direction="row" spacing={2} alignItems="center">
          <PreviewPersonsButton
            persons={additionalRecipients}
            channel={channel}
            buttonText="Named Recipients: "
          >
            <AdditionalRecipientsDatagrid
              channel={channel}
              recipientIds={recipientIds}
              targetChannel={false}
            />
          </PreviewPersonsButton>

          <PreviewTooltip title={tooltipTitle} />
        </Stack>
      </Stack>
    </>
  );
};
